import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../../SimpleBlockContent'
import { $neutralGray50 } from '../../../../../styles/colors/primitives'
import Img from '../../../../Img'

const cx = (...c) => c.filter(Boolean).join(' ')

function LiteWheelImageAndText({ title, text, image1, image2, reversed }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={cx(styles.textWrapper, reversed && styles.textWrapperReversed)}>
          <div className={styles.title}>
            <SimpleBlockContent
              blocks={title.text}
              highlight={title.highlight}
              highlightSx={`color: ${$neutralGray50};`}
              highlightExactMatch={true}
              noSpace
            />
          </div>
          <div className={styles.textBody}>
            <SimpleBlockContent blocks={text} noSpace/>
          </div>
        </div>
        <div className={cx(styles.images, reversed && styles.imagesReversed)}>
          {
            image1 && (
              <div className={cx(styles.imageWrapper, (image1 && image2) && styles.imageWrapperTwo)}>
                {/* task #67: image1 is now a ResolvedImage descriptor */}
                <Img
                  image={image1}
                  alt={title.text}
                  layout="fill"
                  objectFit="contain"
                />
              </div>
            )
          }

          {
            image2 && (
              <div className={cx(styles.imageWrapper, (image1 && image2) && styles.imageWrapperTwo)}>
                {/* task #67: image2 is now a ResolvedImage descriptor */}
                <Img
                  image={image2}
                  alt={title.text}
                  layout="fill"
                  objectFit="contain"
                />
              </div>
            )
          }
        </div>
      </div>
    </div>
  )
}

export default LiteWheelImageAndText
